var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 19,
    viewBox: "0 0 43 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.75 -1.75541e-06L2.59088 0L2.59088 16.5217L28.0682 16.5217C28.0683 17.8904 29.2283 18.9999 30.6592 18.9999C32.09 18.9999 33.25 17.8904 33.2501 16.5217L34.1137 16.5217C34.1138 17.8904 35.2737 18.9999 36.7046 18.9999C38.1355 18.9999 39.2955 17.8904 39.2955 16.5217L42.75 16.5217L42.75 -1.75541e-06Z",
    fill: "#155878"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.0909,
    width: 4.31818,
    height: 1.72727,
    fill: "#155878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckTail);
export default __webpack_public_path__ + "static/media/TruckTail.008346fd2aa194e20d2e31f3fc475831.svg";
export { ForwardRef as ReactComponent };